// import { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Box from "@mui/material/Box";
// import Card from "@mui/material/Card";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepLabel from "@mui/material/StepLabel";
// import Typography from "@mui/material/Typography";
// import Paper from "@mui/material/Paper";

// // Import your components
// import ViewSupervisorEngineer from "./ViewSupervisorEngineers";
// import CreateSupervisorEngineer from "./CreateSupervisorEngineer";

// const steps = [
//   "View Engineers", 
//   "Create Engineer", 
 
// ];

// export default function ManageSiteEngineerWizard() {
//   const [activeStep, setActiveStep] = useState(0);

//   const renderStepContent = (step) => {
//     switch (step) {
//       case 0:
//         return <ViewSupervisorEngineer />;
//       case 1:
//         return <CreateSupervisorEngineer />;
      
//       default:
//         return null;
//     }
//   };

//   return (
//     <Box
//       className="manage-engineer-wrapper"
//       sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}
//     >
//       <Typography
//         variant="h5"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           textAlign: "left",
//           borderBottom: "2px solid #1976d2",
//           display: "inline-block",
//         }}
//       >
//         Manage Site Engineers
//       </Typography>

//       {/* Wizard Stepper Card */}
//       <Card
//         sx={{
//           p: 2,
//           mb: 3,
//           borderRadius: 3,
//           boxShadow: 4,
//           overflowX: "auto",        // allows horizontal scroll
//         }}
//       >
//         <Box sx={{ display: "inline-block", minWidth: "100%" }}>
//           <Stepper
//             activeStep={activeStep}
//             alternativeLabel
//             nonLinear
//             sx={{ minWidth: "max-content" }} // prevents shrinking of steps
//           >
//             {steps.map((label, index) => (
//               <Step key={label}>
//                 <StepLabel
//                   onClick={() => setActiveStep(index)}
//                     StepIconProps={{
//                   sx: {
//                     cursor: "pointer",
//                     fontWeight: "bold",
//                     color: "grey.400",

//                      "& .MuiStepIcon-text": {
//         fill: "#000",
//         fontWeight: "bold",
//       },
//                     "&.Mui-active": {
//                        color: "#EE7F1A",
//                       transform: "scale(1.3)",
//                       transition: "all 0.3s",
//                     },
//                     "&.Mui-completed": {
//                      color: "#EE7F1A",
//                     },
//                   },
//                 }}
//                 sx={{
//                   cursor: "pointer",
//                   "&:hover": { color: "primary.light", fontWeight: "bold" },
//                 }}
//               >
//                   {label}
//                 </StepLabel>
//               </Step>
//             ))}
//           </Stepper>
//         </Box>
//       </Card>

//       {/* Animated Step Content */}
//       <AnimatePresence mode="wait">
//         <motion.div
//           key={activeStep}
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: -20 }}
//           transition={{ duration: 0.3 }}
//         >
//           <Paper
//             elevation={6}
//             sx={{
//               p: 3,
//               borderRadius: 3,
//               minHeight: 400,
//              background: "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)",
//             }}
//           >
//             {renderStepContent(activeStep)}
//           </Paper>
//         </motion.div>
//       </AnimatePresence>
//     </Box>
//   );
// }







import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

// Import your components
import ViewCustomerEngineer from "./ViewCustomerEngineer";
import CreateCustomerEngineer from "./CreateCustomerEngineer";
import MapSiteToCustEngineer from "./MapSiteToCustEngineer";

const steps = [
  "View Engineers", 
  "Create Engineer",
  "Map Site To Engineer" 
 
];

export default function ManageSiteEngineerWizard() {
  const [activeStep, setActiveStep] = useState(0);

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <ViewCustomerEngineer />;
      case 1:
        return <CreateCustomerEngineer />;
      case 2:
        return <MapSiteToCustEngineer/>
      
      default:
        return null;
    }
  };

  return (
    <Box
      className="manage-engineer-wrapper"
      sx={{ maxWidth: 1500, mx: "auto", py: 4, px: 2 }}
    >
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: "bold",
          textAlign: "left",
          borderBottom: "2px solid #1976d2",
          display: "inline-block",
        }}
      >
        Manage Site Engineers
      </Typography>

      {/* Wizard Stepper Card */}
      <Card
        sx={{
          p: 2,
          mb: 3,
          borderRadius: 3,
          boxShadow: 4,
          overflowX: "auto",        // allows horizontal scroll
        }}
      >
        <Box sx={{ display: "inline-block", minWidth: "100%" }}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            nonLinear
            sx={{ minWidth: "max-content" }} // prevents shrinking of steps
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  onClick={() => setActiveStep(index)}
                    StepIconProps={{
                  sx: {
                    cursor: "pointer",
                    fontWeight: "bold",
                    color: "grey.400",

                     "& .MuiStepIcon-text": {
        fill: "#000",
        fontWeight: "bold",
      },
                    "&.Mui-active": {
                       color: "#EE7F1A",
                      transform: "scale(1.3)",
                      transition: "all 0.3s",
                    },
                    "&.Mui-completed": {
                     color: "#EE7F1A",
                    },
                  },
                }}
                sx={{
                  cursor: "pointer",
                  "&:hover": { color: "primary.light", fontWeight: "bold" },
                }}
              >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Card>

      {/* Animated Step Content */}
      <AnimatePresence mode="wait">
        <motion.div
          key={activeStep}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          <Paper
            elevation={6}
            sx={{
              p: 3,
              borderRadius: 3,
              minHeight: 400,
             background: "linear-gradient(135deg, #bdbdbd 10%, #f8fafd 80%)",
            }}
          >
            {renderStepContent(activeStep)}
          </Paper>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
}